<template>
  <div class="container">
    <el-row type="flex" justify="space-between">
      <el-col :span="6">
        <img  src="../../../assets/images/logo/logo4.png" alt="" class="hidden-sm-and-down">
        <img src="../../../assets/images/logo/logo1.png" alt="" class="hidden-md-and-up">
      </el-col>
      <el-col :span="13.5" class="hidden-sm-and-down">
        <el-menu :default-active="$route.path" class="el-menu-demo" mode="horizontal" text-color="#fff"
          active-text-color="#8db83c" :router="true" :unique-opened="true" background-color="#007455">
          <el-menu-item index="/home">首页</el-menu-item>
          <el-menu-item index="/about1/introduce">关于懒精灵</el-menu-item>

          <el-menu-item index="/details3" v-if="$route.path == '/details3' ">艺术涂料与墙艺</el-menu-item>
          <el-menu-item index="/details2" v-else-if="$route.path == '/details2'">艺术涂料与墙艺</el-menu-item>
          <el-menu-item index="/details" v-else>艺术涂料与墙艺</el-menu-item>
          
          <el-menu-item index="/join2" v-if="$route.path == '/join2'">培训加盟</el-menu-item>
          <el-menu-item index="/join" v-else>培训加盟</el-menu-item>

          <el-menu-item index="/dynamic3" v-if="$route.path == '/dynamic3'">动态</el-menu-item>
          <el-menu-item index="/dynamic2" v-else-if="$route.path == '/dynamic2'">动态</el-menu-item>
          <el-menu-item index="/dynamic" v-else>动态</el-menu-item>

          <el-menu-item index="/contact">联系</el-menu-item>
          
        </el-menu>
      </el-col>
      <el-col :span="13.5" class="hidden-md-and-up ">
        <span class="iconfont icon-daohanglan"></span>
      </el-col>
    </el-row>
  </div>
</template>

<script>
// import './base2.css'
export default {
  data () {
    return {
      url: null,
      bg: '#007455'
    };
  },
  methods: {
    //获取数据http://www.codefly.top/#/home
    async getData () {
      const { data: ret } = await this.$http.get('/static/img.json')
      this.url = ret.logo[0].url
    },

  },
  mounted () {
    this.getData()
  },

}
</script>

<style lang='less' scoped>
.el-row {
  align-items: center;
  .iconfont {
    font-size: 1.6rem;
    color: #fff;
    cursor: pointer;
  }
}
</style>